export default "__VITE_ASSET__BJgBdB2c__"